import {
    animate,
    keyframes,
    state,
    style,
    transition,
    trigger
  } from '@angular/animations';
  import { Component } from '@angular/core';
  
  import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
  
  @Component({
    selector: '[plus-toast-component]',
    styleUrls: [`./plus.toast.css`],
    templateUrl: `./plus.toast.html`,
    animations: [

      // trigger('EnterLeave', [
      //   state('flyIn', style({ transform: 'translateX(0)' })),
      //   transition(':enter', [
      //     style({ transform: 'translateX(-100%)' }),
      //     animate('0.5s 300ms ease-in')
      //   ]),
      //   transition(':leave', [
      //     animate('0.3s ease-out', style({ transform: 'translateX(100%)' }))
      //   ])
      // ])

      trigger('flyInOut', [
        // state('inactive', style({ transform: ' translateX(100%)' })),
        state('inactive', style({ opacity: 0 })),
        state('active', style({ opacity: 1 })),
        state('removed', style({ opacity: 0 })),
        transition(
          'inactive => active',[
          // style({ transform: 'translateX(-100%)' }),
          animate('{{ easeTime }}ms {{ easing }}')          
        ]),
        transition(
          'active => removed',
          //animate('{{ easeTime }}ms {{ easing }}')
          animate('0.3s ease-out', style({ opacity: 0 }))

        )
      ])
    ],
    preserveWhitespaces: false,
  })
  export class PlusToast extends Toast {
  
    // constructor is only necessary when not using AoT
    constructor(
      protected toastrService: ToastrService,
      public toastPackage: ToastPackage,
    ) {
      super(toastrService, toastPackage);
    }
  
    action(event: Event) {
      event.stopPropagation();
      this.toastPackage.triggerAction();
      return false;
    }
  }